const highlights = [
  { icon: "ri-leaf-line", title: "Food-Grade SS304 / SS316", desc: "Every unit uses certified food-grade stainless steel that meets HACCP, KEBS, and international hygiene standards." },
  { icon: "ri-settings-3-line", title: "Custom-Engineered Builds", desc: "We design around your production line, volumes, and floor plan — no off-the-shelf compromises." },
  { icon: "ri-verified-badge-line", title: "HACCP & ISO Compliant", desc: "Smooth internal radii, flush welds, crevice-free surfaces — built to pass food safety audits with ease." },
  { icon: "ri-tools-line", title: "Turnkey Installation", desc: "From fabrication to commissioning, our engineers handle the full fit-out at your facility." },
];

export default function FoodOverview() {
  return (
    <section id="overview" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image column */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-lg overflow-hidden">
              <img
                src="/images/food/pasteuriser.webp"
                alt="Food Processing Fabrication"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white rounded-lg p-6 text-center w-36 hidden md:block">
              <p className="text-3xl font-extrabold">15+</p>
              <p className="text-teal-100 text-xs uppercase tracking-wider mt-1">Years of Precision Fabrication</p>
            </div>
          </div>

          {/* Content column */}
          <div>
            <span className="text-teal-600 text-xs font-bold uppercase tracking-widest">Who We Are</span>
            <h2 className="text-gray-900 text-3xl md:text-4xl font-extrabold mt-3 uppercase tracking-tight leading-tight">
              Engineering Excellence for Kenya&apos;s Food Industry
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mt-5">
              ISMAN Engineering has been at the heart of Kenya&apos;s food processing sector for over 15 years,
              fabricating and installing stainless steel equipment for dairy processors, flour millers,
              beverage manufacturers, abattoirs, bakeries, and agro-processing facilities.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mt-3">
              Our Nairobi workshop combines precision CNC cutting, expert TIG welding, and rigorous quality
              inspection to deliver equipment that maximises throughput, minimises contamination risk,
              and stands up to demanding production environments.
            </p>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0">
                    <i className={`${h.icon} text-lg text-teal-600`}></i>
                  </div>
                  <div>
                    <p className="text-gray-900 font-bold text-xs uppercase tracking-wide">{h.title}</p>
                    <p className="text-gray-500 text-xs mt-1 leading-relaxed">{h.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#inquiry"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap mt-10"
            >
              Get a Free Quote <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
